/**
 * API base URL
 * - Development: proxied via Vite (empty string)
 * - Release builds: VITE_API_URL build arg; defaults to the prod custom
 *   domain so a build without the arg is exactly the old prod build.
 */
export const API_BASE_URL = import.meta.env.PROD
	? import.meta.env.VITE_API_URL || 'https://api.redstack.moptisoft.com'
	: ''
